export default __webpack_public_path__ + "static/media/Hellix-SemiBold.9039b0de.otf";